import React from 'react';
import { Link } from 'react-router-dom';
import HarbourPathwayLane from './HarbourPathwayLane';
import HarbourIcon from './HarbourIcon';
import { senStoppedChips } from '../../utils/harbourPupils';
import './harbour.css';

/*
 * Harbour/Pupil card: name and year group, then one lane per pathway — the
 * SEN lane above the referral lane, with the hairline divider between them.
 * Inactive lanes show the quiet "Not active" panel; the add link appears only
 * when the caller supplies the action (the UI never offers an action the
 * system cannot deliver).
 */
export default function HarbourPupilCard({ pupil, recordTo, onAddReferral, onAddSen }) {
  const { name, yearGroup, sen, referral } = pupil;
  return (
    <article className="harbour-pupil-card">
      <span className="harbour-pupil-card__hover-arrow" aria-hidden="true">
        <HarbourIcon name="arrow-right" size={20} />
      </span>
      <div className="flex items-baseline gap-2.5">
        {recordTo ? (
          <Link to={recordTo} className="harbour-pupil-card__name">
            {name}
          </Link>
        ) : (
          <span className="harbour-pupil-card__name">{name}</span>
        )}
        {yearGroup && <span className="harbour-body-16 text-[color:var(--harbour-colour-text-muted)]">{yearGroup}</span>}
      </div>

      <HarbourPathwayLane
        pathway="sen"
        active={Boolean(sen)}
        stage={sen?.stageLabel || sen?.stage}
        rows={sen?.rows || []}
        extraChips={senStoppedChips(sen)}
        onAdd={onAddSen}
        addLabel="Add to SEND pathway"
      />
      <div className="harbour-pupil-card__divider" />
      <HarbourPathwayLane
        pathway="referral"
        active={Boolean(referral)}
        rows={referral?.rows || []}
        onAdd={onAddReferral}
        addLabel="Add to referral pathway"
      />
    </article>
  );
}
